import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';

// Google's wordmark is a bitmap, so it is served from the assets host rather than bundled. Width and
// height are set explicitly to reserve space while it loads, and must stay true to the asset's own
// 119x36 aspect (3.306) — a bitmap fills its content box, so a mismatch stretches the wordmark.
// 60x18 is within 1% of that aspect. For the same reason, offset the image with margin, never
// padding: joykit's global `box-sizing: border-box` makes padding shrink the content box instead.
const GOOGLE_WORD_LOGO_IMAGE = 'https://withjoy.com/assets/public/apps/shared/google-word-logo.png';

export const PoweredByGoogle: React.FC = () => {
  return (
    <Flex
      justifyContent={'flex-end'}
      gap={1}
      padding={3}
    >
      {/* Not translated — must remain in English per Google branding guidelines */}
      <TextV2 typographyVariant={'label1'}>Powered by</TextV2>
      <Flex __css={{ '& > img': { marginBottom: '3px' } }}>
        <img
          src={GOOGLE_WORD_LOGO_IMAGE}
          alt="Google"
          width={60}
          height={18}
        />
      </Flex>
    </Flex>
  );
};
